module.exports = __webpack_public_path__ + "static/img/labyrimental.41b1c3c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/thumbnails/projects/labyrimental.jpg
// module id = W4nW
// module chunks = 0